<template>
  <AppNotFoundPage
    :status-code="statusCode"
    :status-message="statusMessage"
    :path="errorPath"
    :clear-error-on-home="true"
  />
</template>

<script setup>
import { computed } from "vue";
import AppNotFoundPage from "@/components/common/AppNotFoundPage.vue";

const props = defineProps({
  error: {
    type: Object,
    default: () => ({}),
  },
});

const route = useRoute();

const statusCode = computed(() => Number(props.error?.statusCode || props.error?.status || 404));
const statusMessage = computed(() => String(props.error?.statusMessage || props.error?.message || "").trim());
const errorPath = computed(() => {
  const dataPath = props.error?.data?.path;
  if (typeof dataPath === "string" && dataPath.trim()) {
    return dataPath;
  }
  return route.fullPath || "/";
});

const event = process.server ? useRequestEvent() : null;
if (process.server && event) {
  setResponseStatus(event, statusCode.value || 404, statusMessage.value || "");
}
</script>
